import {GameObjectsTags} from '../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {GameObject, Transform2dComponent} from '@specials/gcs-engine';

import {PixiViewRendererComponent} from '@/gcs/PixiViewRendererComponent';

import {CometaDataComponent} from './CometaDataComponent';
import {CometaInteractiveComponent} from './CometaInteractiveComponent';
import {CometaViewComponent} from './CometaViewComponent';

export class Cometa extends GameObject {
  public tag = GameObjectsTags.Bonus;

  constructor(
    public readonly transformComponent: Transform2dComponent,
    public readonly viewComponent: CometaViewComponent,
    public readonly dataComponent: CometaDataComponent,
    public readonly interactiveComponent: CometaInteractiveComponent,
    private readonly rendererComponent: PixiViewRendererComponent,
  ) {
    super();

    this.addComponent(
      this.transformComponent,
      this.viewComponent,
      this.dataComponent,
      this.interactiveComponent,
      this.rendererComponent,
    );
  }
}

injected(
  Cometa,
  DI_TOKENS.transform2dComponent,
  DI_TOKENS.clickerCometaViewComponent,
  DI_TOKENS.clickerCometaDataComponent,
  DI_TOKENS.clickerCometaInteractiveComponent,
  DI_TOKENS.pixiViewRendererComponent,
);
